import React, { useEffect, useState } from 'react';
import Translator from '../../../../core/i18n';
import { useDispatch, useSelector } from 'react-redux';
import { IAppState } from '../../../../models/action/core';
import { Common } from '../../../../core/common';
import { CreateSendContentJob, GetActivityListMadlen, MadlenSendContentAI } from '../../../../store/actions/madlenIntegration';
import { IMainMadlenIntegrationProps } from '../../../../models/components/madlen-integrations';
import Loading from '../../../loading/loading';
import ContentLoader from 'react-content-loader';
import { ActivityTypeEnums } from '../../../../models/enums/ActivityType';
import { getTermName } from '../../../../utils';

const T = Translator.create();
let _common: Common = new Common();

const mapActivityTypeToEnum = (activityType: string): ActivityTypeEnums | null => {
    switch (activityType.toLowerCase()) {
        case 'video':
            return ActivityTypeEnums.Video;
        case 'document':
            return ActivityTypeEnums.Document;
        case 'virtualclass':
            return ActivityTypeEnums.VirtualClass;
        default:
            return null;
    }
};

const WillBeSentActivities: React.FC<IMainMadlenIntegrationProps> = ({ courseId, classId }) => {
    const dispatch = useDispatch();

    const activityData = useSelector((state: IAppState) => state.madlenIntegration.activityData.results);
    const termWeeks = useSelector((state: IAppState) => state.coursePage.courseContentTermWeeks);

    const [allowedActivities, setAllowedActivities] = useState<{ activityId: string; activityType: string }[]>([]);
    const [isAll, setIsAll] = useState(false);
    const [disallowedActivities, setDisallowedActivities] = useState<string[]>([]);

    useEffect(() => {
        getActivities();
    }, []);

    const getActivities = () => {
        dispatch(GetActivityListMadlen(courseId ?? "", classId ?? "", '', false, false, 9999, 0, 'week', 'getActivityListMadlen', 'get'));
    }


    const handleCheckboxChange = (activity: { activityId: string; activityType: string }) => {
        if (isAll) {
            setDisallowedActivities((prev) => {
                if (prev.includes(activity.activityId)) {
                    return prev.filter((id) => id !== activity.activityId);
                } else {
                    return [...prev, activity.activityId];
                }
            });
        } else {
            setAllowedActivities((prevSelectedItems) => {
                if (prevSelectedItems.some((item) => item.activityId === activity.activityId)) {
                    return prevSelectedItems.filter((item) => item.activityId !== activity.activityId);
                } else {
                    return [...prevSelectedItems, activity];
                }
            });
        }
    };

    const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
        const checked = event.target.checked;
        setIsAll(checked);
        setAllowedActivities([]);
        setDisallowedActivities([]);
    };

    const handleStart = () => {
        dispatch(CreateSendContentJob(courseId ?? "", sendContentCallback));
    };

    const sendContentCallback = (value: any) => {

        const updatedAllowedActivities = allowedActivities.map((item) => ({
            ...item,
            activityType: mapActivityTypeToEnum(item.activityType),
        }));

        dispatch(MadlenSendContentAI(value.courseId, classId ?? "", disallowedActivities.length == 0 ? "" : disallowedActivities, isAll, updatedAllowedActivities, value.aiSendedId, value.jobId, "GetUploadMultiQuestionsExcel", "get", resetStates))
    }

    const resetStates = () => {
        setAllowedActivities([]);
        setDisallowedActivities([]);
        setIsAll(false);
    };

    return (
        <div>
            <Loading spinnerId={'getActivityListMadlen'}>
                <div style={{ backgroundColor: '#eeede9', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <ContentLoader
                        speed={2}
                        width={1200}
                        height={600}
                        viewBox="0 0 1200 600"
                        backgroundColor="#d9d9d9"
                        foregroundColor="#ededed"
                    >
                        <rect x="2%" y="20" rx="4" ry="4" width="8%" height="30" />
                        <rect x="12%" y="20" rx="4" ry="4" width="25%" height="30" />
                        <rect x="40%" y="20" rx="4" ry="4" width="15%" height="30" />
                        <rect x="58%" y="20" rx="4" ry="4" width="20%" height="30" />
                        <rect x="80%" y="20" rx="4" ry="4" width="15%" height="30" />

                        {Array.from({ length: 10 }).map((_, index) => {
                            const yOffset = 70 + index * 50;
                            return (
                                <React.Fragment key={index}>
                                    <rect x="2%" y={yOffset} rx="4" ry="4" width="8%" height="40" />
                                    <rect x="12%" y={yOffset} rx="4" ry="4" width="25%" height="40" />
                                    <rect x="40%" y={yOffset} rx="4" ry="4" width="15%" height="40" />
                                    <rect x="58%" y={yOffset} rx="4" ry="4" width="20%" height="40" />
                                    <rect x="80%" y={yOffset} rx="4" ry="4" width="15%" height="40" />
                                </React.Fragment>
                            );
                        })}
                    </ContentLoader>
                </div>
            </Loading>
            <div className="col-12 page-table helpDesk-table p-0 m-t-0" id='getActivityListMadlen_Content'>
                <div>
                    <ul className="px-3" style={{ listStyle: 'none' }}>
                        <li>
                            <div className="row align-items-center">
                                <div className="col-6 d-flex justify-content-start align-items-center">
                                    <div className="tick-radio position-relative">
                                        <input
                                            type="checkbox"
                                            id="select-all"
                                            className="form-radio mr-2"
                                            style={{ zIndex: "unset" }}
                                            onChange={handleSelectAll}
                                            checked={isAll}
                                        />
                                    </div>
                                    <b>{T.t('r_gen_activity_name')}</b>
                                </div>
                                <div className="col-3">
                                    <b>{T.t('r_source_weeks')}</b>
                                </div>
                                <div className="col-3">
                                    <b>{T.t('r_gen_learning_outcome')}</b>
                                </div>
                            </div>
                        </li>
                        {activityData?.map((item: any) => {
                            const activity = { activityId: item.activityId, activityType: item.activityType };
                            const isChecked = isAll
                                ? !disallowedActivities.some((selected) => selected === item.activityId)
                                : allowedActivities.some((selected) => selected.activityId === item.activityId);

                            return (
                                <li style={{ background: "none" }} className='pt-2 pb-2' key={item.activityId}>
                                    <div className="row align-items-center">
                                        <div className="col-6 d-flex justify-content-start align-items-center">
                                            <div className="tick-radio position-relative mr-2">
                                                <input
                                                    type="checkbox"
                                                    name={`chbx_${item.activityId}`}
                                                    id={`chbx_${item.activityId}`}
                                                    className="form-radio mr-2"
                                                    style={{ zIndex: "unset" }}
                                                    onChange={() => handleCheckboxChange(activity)}
                                                    checked={isChecked}
                                                />
                                            </div>
                                            {item.activityType && (
                                                <img
                                                    className="mr-1"
                                                    style={{ width: '16px' }}
                                                    src={_common.GetActivityTypeIcons(item.activityType!)}
                                                    alt="Link Icon" />
                                            )}
                                            <span>
                                                {item.name}
                                            </span>
                                        </div>

                                        <div className="col-3" style={{ fontWeight: 500 }}>
                                            {getTermName(item.termWeekId, termWeeks || [], T) || T.t('r_gen_no_week_info')}
                                        </div>
                                        <div className="col-3">
                                            <span>
                                                {item.learningOutcomeValue ?? T.t('r_gen_learning_outcome_not_selected')}
                                            </span>
                                        </div>
                                    </div>
                                </li>
                            );
                        })}
                        <hr className="bottom-border-2 mx-0" />
                        <div className="d-flex justify-content-end w-100">
                            <button
                                disabled={allowedActivities.length === 0 && !isAll}
                                onClick={handleStart}
                                type="button"
                                className="ml-2 mb-3 category-tag-square tag-green"
                            >
                                {T.t('r_send')}
                                <i className="material-icons ml-2">
                                    send
                                </i>
                            </button>
                        </div>
                    </ul>
                </div>
            </div>
        </div>

    );
};

export default WillBeSentActivities;